<template>
	<div id="material-vendor-stocks-table-main">
		<div class="card mb-3">
			<!-- Bestaende (Qty < 1) -->
			<div class="card-body">
				<div class="d-flex mb-2" id="material-vendor-stocks-top-bar">
					<h3 class="mr-auto" style="margin-bottom: 0px">Mit Bestand</h3>
					<a
							v-if="isMaster"
							class="btn"
							:href="`http://synch.lddmusic.com/material/${material.id}/edit`"
							target="_blank"
					>
						<img src="/images/lddmusic_logo.png" height="30"/>
					</a>
					<a
							v-if="isMaster"
							class="mr-1 btn"
							:href="`http://synch.coseon.com/material/${material.id}/edit`"
							target="_blank"
					>
						<img src="/images/coseon.png" height="30"/>
					</a>
					<a
							v-if="isMaster"
							class="mr-3 btn"
							:href="`http://synch.wr.mplusl.de/material/${material.id}/edit`"
							target="_blank"
					>
						<img
								src="/images/mymediawelt-logo-bigtransparent.png"
								height="30"
						/>
					</a>
					<button
							type="button"
							class="btn btn-secondary table-secondary mr-3 my-0 py-0"
							size="sm"
							@click="
							synch.openMultipleTabs([
								'https://www.amazon.co.uk/gp/product/' + material.asin,
								'https://www.amazon.de/gp/product/' + material.asin,
								'https://www.amazon.fr/gp/product/' + material.asin,
							])
						"
					>
						<!-- button -->
						<span>Bei Amazon nachbestellen</span>
					</button>
					<button
							v-if="isMaster"
							type="button"
							class="btn btn-secondary table-secondary mr-3 my-0 py-0"
							size="sm"
							@click="showCreateStockModal = true"
							:disabled="!(authorization.warehouse_manager ||  authorization.account_manager)"
					>
						<!-- button -->
						<span>+</span>
					</button>
					</div>
					<table class="table table-sm table-hover mb-0" id="material-vendor-stock-table-ohne-bestand">
						<thead>
						<tr>
							<th scope="col" style="width: 200px; max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">Lieferant</th>
							<th scope="col">ArticleId</th>
							<th scope="col">Zustand</th>
							<th scope="col" style="width: 120px">EK</th>
							<th scope="col">E-Porto</th>
							<th scope="col">S-Ertrag</th>
							<th scope="col">S-zuschlag</th>
							<th scope="col">Summe</th>
							<th scope="col">Bestand</th>
							<th scope="col">LK</th>
							<th scope="col" style="width: 80px"><!-- Edit --></th>
						</tr>
						</thead>
						<tbody>
						<material-vendor-stock-table-row
								v-for="stock in stocksWithInventory"
								:stock="stock"
								:stocks="material.stocks"
								:candidateStock="candidateStock"
								:authorization="authorization"
								:key="stock.id"
								:userName="userName"
								@openManualVendorOrder="openManualVendorOrder"
								@openVendorStockBlock="openVendorStockBlock"
								@openVendorCancellation="openVendorCancellation"
						></material-vendor-stock-table-row>
						</tbody>
					</table>
			</div>
		</div>
		<div class="card mb-3">
			<!-- Ohne Bestand (Qty = 0) -->
			<div class="card-body">
				<div class="d-flex mb-2" id="material-vendor-stocks-top-bar">
					<h3 class="mr-auto" style="margin-bottom: 0px">Ohne Bestand</h3>
					</div>
					<table class="table table-sm table-hover mb-0" id="material-vendor-stock-table-ohne-bestand">
						<thead>
						<tr>
							<th scope="col">Lieferant</th>
							<th scope="col">ArticleId</th>
							<th scope="col">Zustand</th>
							<th scope="col" style="width: 120px">EK</th>
							<th scope="col">E-Porto</th>
							<th scope="col">S-Ertrag</th>
							<th scope="col">S-zuschlag</th>
							<th scope="col">Summe</th>
							<th scope="col">Bestand</th>
							<th scope="col">LK</th>
							<th scope="col" style="width: 80px"><!-- Edit --></th>
						</tr>
						</thead>
						<tbody>
						<material-vendor-stock-table-row
								v-for="stock in stocksWithoutInventory"
								:stock="stock"
								:stocks="material.stocks"
								:candidateStock="candidateStock"
								:authorization="authorization"
								:key="stock.id"
								:userName="userName"
								@openManualVendorOrder="openManualVendorOrder"
								@openVendorStockBlock="openVendorStockBlock"
								@openVendorCancellation="openVendorCancellation"
						></material-vendor-stock-table-row>
						</tbody>
					</table>
			</div>
		</div>
	<b-modal
			id="modal-manual-vendor-order"
			v-model="modalManualVendorOrder.state"
			centered
			title="Manuelle Händlerbestellung"
			no-close-on-esc
			no-close-on-backdrop
			hide-header-close
	>
		<div v-if="modalManualVendorOrder.stock != null">
			<form class="px-3">
				<div class="form-group row my-2">
					<label class="control-label col-4">Lieferant</label>
					<label class="control-label col-8 px-0"><b>{{ modalManualVendorOrder.stock.vendor.name }}</b></label>
				</div>
				<div class="form-group row my-2">
					<label class="control-label col-4">Barcode (EAN)</label>
					<label class="control-label col-8 px-0">{{ material.ean }}</label>
				</div>
				<div class="form-group row my-2">
					<label class="control-label col-3">Anzahl</label>
					<input type="text" style="text-align: left;" class="form-control form-control-sm col-9"
								 v-model="modalManualVendorOrder.quantity">
				</div>
				<div class="form-group row my-2">
					<label class="control-label col-3">Referenz</label>

					<input type="text" style="text-align: left;" class="form-control form-control-sm col-9"
								 v-model="modalManualVendorOrder.reference">
				</div>
			</form>
		</div>
		<template #modal-footer>
			<div class="w-100">
				<b-button
						size="md"
						variant="primary"
						class="float-right"
						@click="modalManualVendorOrder.placeOrder()"
				>Bestätigen
				</b-button>
				<b-button
						size="md"
						class="float-right mx-1"
						variant="secondary"
						@click="modalManualVendorOrder.abort()"
				>Abbrechen
				</b-button>
			</div>
		</template>
	</b-modal>
	<material-vendor-stock-block-component
			:passedStock="passingStock"
			:openVendorStockBlockModal="openVendorStockBlockModal"
			@closedVendorStockBlock="closedVendorStockBlock"
			@updateStock="emit_updateStock"
			@error="showErrorModal"
	></material-vendor-stock-block-component> <!--open(stock)-->
		<b-modal
				v-model="vendorCancellation.state"
				id="modal-vendor-cancellation"
				title="Händlerstorno"
				@ok="vendorCancellation.submit()"
				cancel-title="abbrechen"
				size="md"
		><!-- modal -->
			Händler: <strong>{{ vendorCancellation.stock.vendor.name }}</strong><br>
			<div class="d-flex">
				Menge:
				<b-form-input
						style="max-width: 100px;"
						class="ml-2"
						v-model="vendorCancellation.quantity"
						type="number"
						:min="1"
						:max="15"
						size="sm">
				</b-form-input>
			</div>

			Sie sie sicher, dass sie diesen Artikel stornieren möchten?<br>
		</b-modal>

		<b-modal
				v-model="showCreateStockModal"
				title="Stock erstellen"
				ok-title="Speichern"
				cancel-title="Abbrechen"
				@ok="saveStock"
		>
			<b-form-group label="Article-ID">
				<b-form-input v-model="newStock.articleId" />
			</b-form-group>

			<b-form-group label="EK">
				<b-form-input v-model.number="newStock.purchasePrice" type="number" step="0.01" />
			</b-form-group>

			<b-form-group label="Menge">
				<b-form-input v-model.number="newStock.quantity" type="number" step="1" />
			</b-form-group>

			<b-form-group label="Lager">
				<b-form-select v-model="newStock.vendorId" :options="stockOptions" />
			</b-form-group>
		</b-modal>
	<modal-error-component v-model="modalError"></modal-error-component>
	</div>
</template>
<script>
export default {
	props: [
		"authorization",
		"isMaster",
		"material",
		"userName",
	],
	data() {
		return {
			candidateStock: {
				articleId: null,
				editId: null,
				saveId: null,
				purchasePrice: null, //old values, if aborted
				quantity: null,
			},
			openVendorStockBlockModal: false,
			passingStock: null,
			showCreateStockModal: false,
			newStock: {
				articleId: null,
				purchasePrice: null,
				quantity: 0,
				vendorId: 8,
			},
			stockOptions: [
				{ value: 8, text: 'Lager4' },
				{ value: 27, text: 'Lager7' },
			],
			modalError: {
				show: false,
				title: '',
				error: '',
				message: ''
			},
			modalManualVendorOrder: {
				state: false,
				stock: null,
				quantity: null,
				reference: null,
				abort: () => {
					this.modalManualVendorOrder.stock = null;
					this.modalManualVendorOrder.quantity = null;
					this.modalManualVendorOrder.reference = null;
					this.modalManualVendorOrder.state = false;
				},
				placeOrder: () => {
					let qty = null;
					try {
						qty = Number(this.modalManualVendorOrder.quantity);
					} catch (error) {
						this.$bvToast.toast(`Anzahl »${this.modalManualVendorOrder.quantity}« muss ganzzahlige Zahl (...,-2,-1,0,1,2,3,...) sein`, {
							title: "Manuelle Bestellung",
							autoHideDelay: 5000,
							appendToast: false,
							variant: 'danger',
						});
						return;
					}

					if (["", null, undefined].includes(this.modalManualVendorOrder.quantity) || isNaN(this.modalManualVendorOrder.quantity) || (qty != Math.floor(qty))) {
						this.$bvToast.toast(`Anzahl »${this.modalManualVendorOrder.quantity}« muss ganzzahlige Zahl (...,-2,-1,0,1,2,3,...) sein`, {
							title: "Manuelle Bestellung",
							autoHideDelay: 5000,
							appendToast: false,
							variant: 'danger',
						});
						return;
					}

					if (["", null, undefined].includes(this.modalManualVendorOrder.reference)) {
						this.$bvToast.toast("Referenz darf nicht leer sein.", {
							title: "Manuelle Bestellung",
							autoHideDelay: 5000,
							appendToast: false,
							variant: 'danger',
						});
						return;
					}

					this.modalManualVendorOrder.state = false;

					const payload = {
						stock: this.modalManualVendorOrder.stock,
						material: this.material,
						reference: this.modalManualVendorOrder.reference,
						quantity: this.modalManualVendorOrder.quantity
					};

					axios.post("/material/manualvendororder", payload)
							.then(this.modalManualVendorOrder.abort)
							.catch(err => {
								console.error(err);
								this.$bvToast.toast("Fehler (Manual Vendor Order): konnte Request nicht durchführen.", {
									title: "Fehler",
									noAutoHide: true,
									appendToast: false,
									variant: 'danger'
								});
							});
				},
			},
			vendorCancellation: {
				state: false,
				stock: null,
				quantity: 1,
				abort: () => {
					this.vendorCancellation.stock = null;
					this.vendorCancellation.quantity = 1;
					this.vendorCancellation.state = false;
				},
				submit: () => {
					const payload = {
						quantity: this.vendorCancellation.quantity,
						customerOrderId: null,
						stockId: this.vendorCancellation.stock.id
					};
					axios.post('/customerorder/action/vendorcancellation', payload)
							.then(() => {
								this.vendorCancellation.state = false;
								//success toast
								this.$bvToast.toast('Die Stornierung wurde erfolgreich erstellt.', {
									title: 'Stornierung erstellt',
									variant: 'success',
									solid: true
								});

							}).catch(error => {
						console.error(error);
						this.vendorCancellation.state = false;
						this.modalError = {
							show: true,
							error: error,
							title: 'Fehler beim Erstellen der Stornierung',
						};
					});
				}
			},
		};
	},
	computed: {
		stocksWithoutInventory: function () {
			return this.material.stocks
					.map(stock => {
						stock.sumPurchasePriceAndShippingFee = Number(stock.vendorShippingFee) + Number(stock.purchasePrice);
						stock.sumPurchasePriceAndShippingFeeStr = Number(
								stock.sumPurchasePriceAndShippingFee
						).toFixed(2);
						return stock;
					})
					.filter(stock => stock.quantity <= 0)
					.sort(this.stocksNameSorter);
		},
		stocksWithInventory: function () {
			return this.material.stocks
					.map(stock => {
						stock.sumPurchasePriceAndShippingFee =
								Number(stock.vendorShippingFee) + Number(stock.purchasePrice);
						stock.sumPurchasePriceAndShippingFeeStr = Number(
								stock.sumPurchasePriceAndShippingFee
						).toFixed(2);
						return stock;
					})
					.filter(stock => stock.quantity > 0)
					.sort(this.stockSortComparator);
		},
	},
	methods: {
		stockSortComparator(v, w) {
			return v.sumPurchasePriceAndShippingFee - w.sumPurchasePriceAndShippingFee;
		},
		stocksNameSorter(a, b) {
				if ((a.vendor.shortForm ?? a.vendor.name) < (b.vendor.shortForm ?? b.vendor.name)) return -1;
				if ((a.vendor.shortForm ?? a.vendor.name) > (b.vendor.shortForm ?? b.vendor.name)) return 1;
				return 0;
		},
		openManualVendorOrder(stock) {
			this.modalManualVendorOrder.state = true;
			this.modalManualVendorOrder.stock = stock;
		},
		openVendorStockBlock(stock) {
			this.openVendorStockBlockModal = true;
			this.passingStock = stock;
			// console.log('table emit, open modal + passing stock');
		},
		closedVendorStockBlock() {
			this.openVendorStockBlockModal = false;
			// console.log('modal was closed');
		},
		openVendorCancellation(stock){
			this.vendorCancellation.state = true;
			this.vendorCancellation.stock = stock;
		},
		emit_updateStock(stockIds, mode) {
			let stocks = this.material.stocks.filter(stock => stockIds.includes(stock.id))

			if (mode === 'created') {
				stocks.forEach(stock => {
					stock.vendorStockBlock = true;
					stock.quantity = 0;
				});
			} else {
				stocks.forEach(stock => {
					stock.vendorStockBlock = false
				});
			}

			this.$emit('updateStock', stocks);
		},
		showErrorModal(_title = '', _error = '', _message = '') {
			this.modalError = {
				show: true,
				title: _title,
				error: _error,
				message: _message
			};
		},
		saveStock() {
			axios.post('/stock/manual/save', {
				articleId: this.newStock.articleId,
				purchasePrice: this.newStock.purchasePrice,
				vendorId: this.newStock.vendorId,
				materialId: this.material.id,
				quantity: this.newStock.quantity,
			}).then(response => {
				this.showCreateStockModal = false;

				this.material.stocks.push(response.data[0]);

				this.newStock.articleId = null;
				this.newStock.purchasePrice = null;
				this.newStock.quantity = 0;
				this.newStock.vendorId = 8;

				this.$bvToast.toast('Stock erfolgreich erstellt.', {
					title: 'Stock erstellt',
					variant: 'success',
					solid: true
				});
			}).catch(error => {
				console.error(error);
				this.modalError = {
					show: true,
					title: 'Fehler beim Erstellen des Stocks',
					error: (error.response?.data?.message ?? error.response?.data?.error) ?? error.response?.data ??  error.message ?? error,
					message: error,
				};
			});
		},
	}
};
</script>
